export default [{
  name: 'revo',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PF: {},
        PJ: {},
        TipoPessoa: null,
        PessoaDadosContato: {},
        PessoaDadoFinanceiro: {},
        PessoaEndereco: {},
        PessoaQualificacao: {},
      },
      Parcela: {},
      ImovelProprio: null,
      DadosIniciais: {},
      PropostaGarantiaBemMovel: {},
      EnderecoInstalacao: {},
    },
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
  },
  getters: {
    model (state) {
      return state.model
    },
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PF: {},
          PJ: {},
          TipoPessoa: null,
          PessoaDadosContato: {},
          PessoaDadoFinanceiro: {},
          PessoaEndereco: {},
          PessoaQualificacao: {},
        },
        Parcela: {},
        ImovelProprio: null,
        DadosIniciais: {},
        PropostaGarantiaBemMovel: {},
        EnderecoInstalacao: {},
      }
      commit('model', data)
    }
  },
}]
